export function getCookie(name: string): string | null {
  const nameEQ = name + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  for (let i = ca.length - 1; i >= 0; i--) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export function getAuthCookieAttributes(includeExpires: boolean = true): string {
  const isHttps = window.location.protocol === "https:";
  const expires = includeExpires
    ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT"
    : "";
  const secure = isHttps ? "; Secure" : "";
  return `path=/${expires}${secure}; SameSite=Strict`;
}

export function clearAllAuthCookies(): void {
  for (const name of ["userToken", "userId", "userEmail", "userFirstName", "userLastName", "userIsVerified", "userRole"]) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; ${getAuthCookieAttributes(false)}`;
  }
}

export const clearUserSessionCookies = clearAllAuthCookies;
